import { MainAssignComponent } from "./components/main-assign.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'assign',
        component: MainAssignComponent,
        canActivate: [AuthService],
        data: { title: 'Servicios' }
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class AssignRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/assign/assign.routes.ts